import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-border last:border-0" data-id="element-11">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg px-2" onClick={onClick} aria-expanded={isOpen} data-id="element-12">
        <span className="text-lg font-semibold text-foreground pr-8" data-id="element-13">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-muted-foreground transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-14" />
      </button>
      <AnimatePresence initial={false} data-id="element-15">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-16">
            <div className="pb-6 px-2 text-foreground/80 text-lg leading-relaxed" data-id="element-17">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Does it really work in 3 days?',
    answer: 'Yes—if you follow the protocol with zero "just in case" diapers.'
  }, {
    question: 'What about naps and nighttime?',
    answer: "You'll get a specific sleep strategy inside the guide."
  }, {
    question: 'Do I need expensive potty-training gear?',
    answer: 'No—just a basic potty setup and the supplies listed.'
  }, {
    question: 'What if my kid is super stubborn?',
    answer: "This method doesn't depend on personality. It uses biology to build the habit."
  }, {
    question: 'Is it for boys and girls?',
    answer: 'Yes—the learning process is the same.'
  }];
  return <section className="py-20 px-4" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-21">
            Common Questions
          </h2>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-border" data-id="element-22">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-23" />)}
        </div>
      </div>
    </section>;
}